import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverlijdenMelden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M20 17c3.31 0 6 2.63 6 5.88V34H14V22.88c0-3.25 2.69-5.88 6-5.88"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M20 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverlijdenMelden);

export default ForwardRef;
